import {
  Box,
  Button,
  FormControl,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Avatar,
  Tooltip,
  Chip,
  Divider,
  CircularProgress,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import TitleWithAddButton from "../Home/TitleWithAddButton";
import Loader from "../../Components/Loader";
import ReusableDrawer from "../../Components/ReusableDrawer";
import UploadIcon from "@mui/icons-material/Upload";
import StorageFactory from "../../Util/StorageFactory";
import {
  ACCESS_RESTRICTED_MESSAGE,
  SESSION_USER_ID_KEY,
  SESSION_USER_ROLES_PERMISSIONS,
} from "../../Util/VMConstants";
import axios from "axios";
import {
  API_GET_VISITORS_LIST,
  API_SUBMITT_VISIT_FORM,
  API_UPLOAD_VEHICLE_IMG,
  API_UPLOAD_VISITOR_IMG,
  API_VISITOR_UPDATE_CHECKOUT,
} from "../../Util/URLConstants";
import { toast } from "react-toastify";
import { align_center, dataGridStyle } from "../../Styles/VMStyles";
import MUITypography from "../../Components/MUITypography";
import {
  checkIsPermissionExist,
  formatWallClockIsoForApi,
  formattedWallClockDateTime,
  isEmpty,
} from "../../Util/UtilHelper";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import MuiTypographyMandatory from "../../Components/Custom/MuiTypographyMandatory";
import StyledInputField from "../../Components/Custom/StyledInputField";
import VMFilters from "../../Components/VMFilters";
import dayjs from "dayjs";
import SubscriptionDialog from "../../Util/SubscriptionDialog";
import { useSelector } from "react-redux";
import NoPermission from "../../Components/NoPermission";
import ReusableDataGrid from "../../Components/ReusableDataGrid";

const typeOptions = ["Guest","Employee /Staff","Event Vendor","Others"];

const getInitialVisitorForm = () => ({
  name: "",
  type: "",
  custom_type: "",
  phone_no: "",
  purpose: "",
  vehicle_no: "",
  visitor_photo: null,
  vehicle_photo: null,
  check_in: dayjs(),
});

function VMVisitorLog() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
  const [rows, setRows] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [viewDrawerOpen, setViewDrawerOpen] = useState(false);
 const [openSubscribeDialog, setOpenSubscribeDialog] = useState(false);

  const [form, setForm] = useState(getInitialVisitorForm);

  const subscriptionStatus = useSelector(
    (state) => state.subscription.status
  );
  
  
  const sessionFactory = new StorageFactory("session");
  const userID = sessionFactory.get(SESSION_USER_ID_KEY);
  const VM_PERMISSIONS = sessionFactory.get(SESSION_USER_ROLES_PERMISSIONS);

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const [checkoutDialogOpen, setCheckoutDialogOpen] = useState(false);
  const [checkoutSubmitting, setCheckoutSubmitting] = useState(false);
  const [selectedVisitor, setSelectedVisitor] = useState(null);
  const [checkoutDateTime, setCheckoutDateTime] = useState(null);
  const [searchText, setSearchText] = useState("");

  const [imagePreview, setImagePreview] = useState(null);

  const handleFromDateChange = (date) => {
    setFromDate(date ? dayjs(date).format("YYYY-MM-DD") : "");
  };

  const handleToDateChange = (date) => {
    setToDate(date ? dayjs(date).format("YYYY-MM-DD") : "");
  };

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        user_id: userID,
        page,
        no_of_rows: pageSize,
        search: searchText,
      });

      if (fromDate) params.append("from_date", fromDate);
      if (toDate) params.append("to_date", toDate);

      const url = `${API_GET_VISITORS_LIST}?${params.toString()}`;
      const res = await fetch(url);
      const resp = await res.json();

      if (resp.status_code === 200 && Array.isArray(resp.data)) {
        setRows(resp.data);
        setTotalCount(resp.count || 0);
      } else {
        toast.error(resp.message || "Unexpected response from server");
        setRows([]);
      }
    } catch (err) {
      console.error("Error fetching visitors:", err);
      toast.error("Failed to load visitors");
      setRows([]);
    } finally {
      setLoading(false);
    }
  }, [fromDate, page, pageSize, searchText, toDate, userID]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const columns = [
    {
      field: "s_no",
      headerName: "S.No",
      width: 80,
    sortable: false,
      align: "center",
    headerAlign: "center",
      renderCell: (params) => {
        const index = params.api.getRowIndexRelativeToVisibleRows(params.id);
        return page * pageSize + index + 1;
      },
    },
    { field: "name", headerName: "Visitor Name", flex: 1 },
    { field: "type", headerName: "Type", flex: 0.6 },
    { field: "purpose", headerName: "Purpose", flex: 0.8 },
    {
      field: "check_in",
      headerName: "Check-In",
      flex: 1,
      renderCell: (p) => formattedWallClockDateTime(p.value),
    },
    {
      field: "check_out",
      headerName: "Check out",
      flex: 1,
      sortable: false,
      renderCell: (params) => (
        <Tooltip title={params.value ? formattedWallClockDateTime(params.value) : "Update check-out"}>
          <Box sx={{ ...align_center, height: '100%' }}>
            {isEmpty(params.value) ? (
        <Button
          size="small"
                variant="outlined"
                color="primary"
          onClick={() => {
            setSelectedVisitor(params.row);
                  setCheckoutDateTime(dayjs());
                  setCheckoutDialogOpen(true);
          }}
        >
                Update
        </Button>
            ) :
             (
              <MUITypography variant='h5' sx={{ height:'100%', ...align_center }}>
              {formattedWallClockDateTime(params.value)}
            </MUITypography>
            )
            }
          </Box>
        </Tooltip>
      ),
    },
    { field: "view", headerName: "View", width: 100, renderCell: (params) => ( <Button variant="outlined" size="small" onClick={() => { setSelectedVisitor(params.row); setViewDrawerOpen(true); }} > View </Button> ), },
    {
  field: "actions",
  headerName: "Photos",
  width: 110,
  sortable: false,
  align: "center",
  headerAlign: "center",

  renderCell: (params) => (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
        width: "100%",
      }}
    >
      {/* 👤 Visitor Photo */}
      <Tooltip title="Visitor Photo">
        <Avatar
          src={params.row.visitor_photo || ""}
          sx={{
            width: 32,
            height: 32,
            cursor: "pointer",
          }}
          onClick={() => setImagePreview(params.row.visitor_photo)}
        >
          {params.row.name?.[0]}
        </Avatar>
      </Tooltip>

      {/* 🚗 Vehicle Photo */}
      <Tooltip title="Vehicle Photo">
        <Avatar
          src={params.row.vehicle_photo || ""}
          sx={{
            width: 32,
            height: 32,
            cursor: "pointer",
          }}
          onClick={() => setImagePreview(params.row.vehicle_photo)}
        >
          V
        </Avatar>
      </Tooltip>
    </Box>
  ),
}
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleFileChange = (e, field) => {
    const file = e.target.files[0];
    if (file) {
      setForm((prev) => ({ ...prev, [field]: file }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!form.name.trim()) newErrors.name = "Name is required";
    if (!form.type) newErrors.type = "Type is required";
    if (form.type === "Others" && !form.custom_type.trim()) {
      newErrors.custom_type = "Please enter custom type";
    }
    if (!form.phone_no.trim()) {
      newErrors.phone_no = "Phone number is required";
    } else if (!/^\d{10}$/.test(form.phone_no)) {
      newErrors.phone_no = "Enter a valid 10-digit number";
    }
    if (!form.check_in) {
      newErrors.check_in = "Check-in date and time is required";
    } else {
      const checkIn = dayjs(form.check_in);
      if (!checkIn.isValid()) {
        newErrors.check_in = "Invalid check-in date and time";
      } 
      // else if (checkIn.isBefore(dayjs(), "minute")) {
      //   newErrors.check_in = "Check-in cannot be in the past";
      // }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    try {
      setLoading(true);

      let visitorPhotoUrl = "";
      let vehiclePhotoUrl = "";

      if (form.visitor_photo) {
        const formData = new FormData();
        formData.append("file", form.visitor_photo);
        formData.append("visitor_id", userID);
        formData.append("user_id", userID);

        const res = await axios.post(API_UPLOAD_VISITOR_IMG, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        if (res.data?.status_code === 200) {
          visitorPhotoUrl = res.data?.data?.file_url;
        } else {
          throw new Error(res.data?.message || "Visitor photo upload failed");
        }
      }

      if (form.vehicle_photo) {
        const formData = new FormData();
        formData.append("file", form.vehicle_photo);
        formData.append("visitor_id", userID);
        formData.append("user_id", userID);

        const res = await axios.post(API_UPLOAD_VEHICLE_IMG, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        if (res.data?.status_code === 200) {
          vehiclePhotoUrl = res.data?.data?.file_url;
        } else {
          throw new Error(res.data?.message || "Vehicle photo upload failed");
        }
      }

      const reqBody = {
        name: form.name,
        type: form.type === "Others" ? form.custom_type : form.type,
        phone_no: form.phone_no,
        purpose: form.purpose,
        vehicle_no: form.vehicle_no,
        user_id: userID,
        visitor_photo: visitorPhotoUrl,
        vehicle_photo: vehiclePhotoUrl,
        check_in: formatWallClockIsoForApi(form.check_in),
      };

      const resp = await axios.post(API_SUBMITT_VISIT_FORM, reqBody);

      if (resp.data?.status_code === 200) {
        toast.success("Visitor added successfully!");
        setDrawerOpen(false);
        setForm(getInitialVisitorForm());
        setPage(0);
        setTimeout(() => {
          fetchData();
        }, 0);
      } else {
        throw new Error(resp.data?.message || "Failed to submit visitor form");
      }
    } catch (err) {
      console.error("Error submitting visitor form:", err);
      toast.error(err.message || "Failed to submit visitor form");
    } finally {
      setLoading(false);
    }
  };

  const handleCheckoutSubmit = async () => {
    try {
      setCheckoutSubmitting(true);
      await axios.post(API_VISITOR_UPDATE_CHECKOUT, {
        id: selectedVisitor.id,
        check_out: formatWallClockIsoForApi(checkoutDateTime),
      });
      setCheckoutDialogOpen(false);
      setSelectedVisitor(null);
      setCheckoutDateTime(null);
      fetchData();
    } catch (error) {
      console.error("Checkout update failed:", error);
      toast.error("Failed to update check-out");
    } finally {
      setCheckoutSubmitting(false);
    }
  };

  return (
    <Box p={1}>

      <TitleWithAddButton
        title="Visitors Log"
        onAddClick={() => 
          {
              if (subscriptionStatus?.plan === 'premium' || subscriptionStatus?.plan === 'trial') {
                setForm(getInitialVisitorForm());
                setErrors({});
                setDrawerOpen(true);
                setOpenSubscribeDialog(false);
              } else {
                setOpenSubscribeDialog(true);
              }
          }
        }
        buttonLabel="Add Visitor"
        isButtonDisplay={checkIsPermissionExist(VM_PERMISSIONS, "VM024")}
      />
      
      <VMFilters
        searchValue={searchText}
        searchOnChange={(e) => setSearchText(e.target.value)}
        fromDateValue={fromDate ? dayjs(fromDate) : null}
        fromDateOnChange={handleFromDateChange}
        toDateValue={toDate ? dayjs(toDate) : null}
        toDateOnChange={handleToDateChange}
        clearOnChange={() => {
          setFromDate("");
          setToDate("");
          setSearchText("");
          fetchData();
        }}
        applyOnChange={() => fetchData()}
        isToalCountDisplay={true}
        totalCount={totalCount}
      />

      <Box pt={2}>
        {checkIsPermissionExist(VM_PERMISSIONS,"VM025") ? (
          <ReusableDataGrid
            rows={rows}
            columns={columns}
            loading={loading}
            rowCount={totalCount}
          page={page}
          pageSize={pageSize}
            pagination
            paginationMode="server"
             getRowHeight={() => 'auto'} 
          onPageChange={(newPage) => setPage(newPage)}
          onPageSizeChange={(newSize) => {
            setPageSize(newSize);
            setPage(0);
          }}
          disableSelectionOnClick
          disableColumnFilter
          disableColumnSelector
          disableDensitySelector
          disableColumnMenu
          hideFooterSelectedRowCount
          rowsPerPageOptions={[5, 10, 20]}
            paginationModel={{ page, pageSize }}
            onPaginationModelChange={(m)=>{
              setPage(m.page);
              setPageSize(m.pageSize);
            }}
            pageSizeOptions={[5,10,20]}
            sx={dataGridStyle}
          />
      )
    : <Box sx={{ mt: 4 }}>
            <NoPermission message={ACCESS_RESTRICTED_MESSAGE} />  
        </Box>}

      </Box>


      {/* Image Preview Dialog */}
      <Dialog open={!!imagePreview} onClose={() => setImagePreview(null)} maxWidth="md">
        <DialogContent sx={{ textAlign: "center" }}>
          {imagePreview ? (
            <img
              src={imagePreview}
              alt="Preview"
              style={{ maxWidth: "100%", maxHeight: "80vh", borderRadius: "8px" }}
            />
          ) : (
            <Typography>No Image</Typography>
          )}
        </DialogContent>
      </Dialog>

      {/* Add Visitor Drawer */}
      <ReusableDrawer
        open={drawerOpen}
        title="Add Visitor"
        onClose={() => {
          setDrawerOpen(false);
          setForm(getInitialVisitorForm());
          setErrors({});
        }}
        showFooter
        loading={loading}
        onSubmit={handleSubmit}
      >
        <Box sx={{ width: 400, pl: 3 }}>
          <Stack spacing={2}>
            <MuiTypographyMandatory label="Name" required />
            <StyledInputField
              name="name"
              fullWidth
              value={form.name}
              onChange={handleChange}
              error={!!errors.name}
              helperText={errors.name}
            />
            <MuiTypographyMandatory label="Type" required />
            <FormControl fullWidth error={!!errors.type}>
              <Select
                name="type"
                value={form.type}
                onChange={handleChange}
                displayEmpty
              >
                <MenuItem value="" disabled>
                  -- Select --
                </MenuItem>
                {typeOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
              {errors.type && (
                <Typography variant="caption" color="error">
                  {errors.type}
                </Typography>
              )}
            </FormControl>

            {form.type === 'Others' && (
              <>
                <MuiTypographyMandatory label="Custom Type" required />
                <StyledInputField
                  name="custom_type"
                  fullWidth
                  value={form.custom_type}
                  onChange={handleChange}
                  error={!!errors.custom_type}
                  helperText={errors.custom_type}
                />
              </>
            )}
              <StyledInputField
            heading="Phone Number"
            name="phone_no"
            type="number"
            required={true}
            placeholder="Enter Phone Number"
            value={form.phone_no}
            onChange={handleChange}
            error={!!errors.phone_no}
            helperText={errors.phone_no}
            inputProps={{ 
              maxLength: 15, 
              inputMode: "numeric", // for mobile number keypad
              pattern: "[0-9]*",    // ensures only numbers
            }}
            style={{ mt: 1 }}
          />
            <MuiTypographyMandatory label="Purpose" />
            <StyledInputField
              name="purpose"
              fullWidth
              placeholder="Enter purpose of visit"
              value={form.purpose}
              onChange={handleChange}
            />
            <MuiTypographyMandatory label="Vehicle Number" />
            <StyledInputField
              name="vehicle_no"
              fullWidth
              value={form.vehicle_no}
              onChange={handleChange}
            />

            <MuiTypographyMandatory label="Check-In" required />
            <DateTimePicker
              value={form.check_in}
              referenceDate={form.check_in || dayjs()}
              minDate={dayjs().startOf("day")}
              onChange={(newValue) => {
                setForm((prev) => ({ ...prev, check_in: newValue }));
                setErrors((prev) => ({ ...prev, check_in: "" }));
              }}
              disablePast
              format="DD/MM/YYYY hh:mm A"
              disabled={true}
              slotProps={{
                textField: {
                  fullWidth: true,
                  error: !!errors.check_in,
                  helperText: errors.check_in || "",
                },
              }}
            />

            <Button component="label" variant="outlined" startIcon={<UploadIcon />}>
              {form.visitor_photo ? 'Photo Selected' : 'Add Visitor Photo'}
              <input
                type="file"
                hidden
                accept="image/*"
                onChange={(e) => handleFileChange(e, 'visitor_photo')}
              />
            </Button>
            {form.visitor_photo && (
              <Typography variant="body2" color="text.secondary">
                {form.visitor_photo.name}
              </Typography>
            )}

            <Button component="label" variant="outlined" startIcon={<UploadIcon />}>
              {form.vehicle_photo ? 'Vehicle Photo Selected' : 'Add Vehicle Photo'}
              <input
                type="file"
                hidden
                accept="image/*"
                onChange={(e) => handleFileChange(e, 'vehicle_photo')}
              />
            </Button>
            {form.vehicle_photo && (
              <Typography variant="body2" color="text.secondary">
                {form.vehicle_photo.name}
              </Typography>
        )}
          </Stack>
        </Box>
      </ReusableDrawer>


      <SubscriptionDialog
        open={openSubscribeDialog}
        onClose={() => setOpenSubscribeDialog(false)}
        onSubscribe={() => {
          setOpenSubscribeDialog(false);
          window.location.href = '/subscription';
        }}
      />

      {/* Checkout Dialog */}
      <Dialog
        open={checkoutDialogOpen}
        onClose={() => {
          if (!checkoutSubmitting) setCheckoutDialogOpen(false);
        }}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          <MUITypography sx={align_center}>Update Check-Out</MUITypography>
        </DialogTitle>
        <DialogContent>
          <Box mt={3} mb={2}>
            <Typography sx={{ mb: 3 }}>
              Visitor: <strong>{selectedVisitor?.name}</strong>
            </Typography>
            <MuiTypographyMandatory label="Check-Out" required />
            <DateTimePicker
              value={checkoutDateTime}
              referenceDate={checkoutDateTime || dayjs()}
              minDate={dayjs().startOf("day")}
              onChange={(newValue) => setCheckoutDateTime(newValue)}
              disablePast
              format="DD/MM/YYYY hh:mm A"
              disabled
              slotProps={{
                textField: {
                  fullWidth: true,
                },
              }}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setCheckoutDialogOpen(false)}
            color="secondary"
            disabled={checkoutSubmitting}
          >
            Cancel
          </Button>
          <Button
            onClick={handleCheckoutSubmit}
            variant="contained"
            disabled={checkoutSubmitting}
            startIcon={
              checkoutSubmitting ? (
                <CircularProgress size={18} color="inherit" />
              ) : null
            }
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      {/* <Loader loading={loading} /> */}
      <Box sx={{ position: "relative" ,...align_center}}>
        {loading ? <CircularProgress loading={loading} /> : null}
      </Box>


<ReusableDrawer
  open={viewDrawerOpen}
  title="Visitor Details"
  onClose={() => setViewDrawerOpen(false)}
  showFooter={false}
>
  {selectedVisitor && (
    <Box sx={{ width: { xs: "100%", sm: 420 }, p: 2 }}>

      {/* HEADER */}
      <Box display="flex" alignItems="center" gap={2} mb={3}>
        <Avatar
          src={selectedVisitor.visitor_photo || ""}
          sx={{ width: 70, height: 70 }}
        >
          {selectedVisitor.name?.[0]}
        </Avatar>

        <Box>
          <Typography variant="h6">
            {selectedVisitor.name || "-"}
          </Typography>

          <Typography color="text.secondary">
            {selectedVisitor.type || "-"}
          </Typography>

          <Chip
            label={selectedVisitor.check_out ? "Checked Out" : "Active"}
            color={selectedVisitor.check_out ? "default" : "success"}
            size="small"
            sx={{ mt: 1 }}
          />
        </Box>
      </Box>

      <Divider sx={{ mb: 2 }} />

      {/* DETAILS GRID */}
      <Box
        display="grid"
        gridTemplateColumns="1fr 1fr"
        gap={2}
      >
        <DetailItem label="Phone" value={selectedVisitor.phone_no} />
        <DetailItem label="Purpose" value={selectedVisitor.purpose} />
        <DetailItem label="Vehicle" value={selectedVisitor.vehicle_no} />
        <DetailItem
          label="Check-In"
          value={formattedWallClockDateTime(selectedVisitor.check_in)}
        />
        <DetailItem
          label="Check-Out"
          value={
            selectedVisitor.check_out
              ? formattedWallClockDateTime(selectedVisitor.check_out)
              : "Not Checked Out"
          }
        />
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* PHOTOS SECTION */}
      <Typography variant="subtitle1" fontWeight={600}>
        Photos
      </Typography>

      <Box display="flex" gap={2} mt={1}>
        {/* Visitor Photo */}
        <Avatar
          src={selectedVisitor.visitor_photo || ""}
          variant="rounded"
          sx={{ width: 90, height: 90, cursor: "pointer" }}
          onClick={() =>
            selectedVisitor.visitor_photo &&
            setImagePreview(selectedVisitor.visitor_photo)
          }
        />

        {/* Vehicle Photo */}
        <Avatar
          src={selectedVisitor.vehicle_photo || ""}
          variant="rounded"
          sx={{ width: 90, height: 90, cursor: "pointer" }}
          onClick={() =>
            selectedVisitor.vehicle_photo &&
            setImagePreview(selectedVisitor.vehicle_photo)
          }
        />
      </Box>
    </Box>
  )}
</ReusableDrawer>

    </Box>
  );
}

const DetailItem = ({ label, value }) => (
  <Box>
    <Typography variant="caption" color="text.secondary">
      {label}
    </Typography>
    <Typography fontWeight={500}>{value || "-"}</Typography>
  </Box>
);

export default VMVisitorLog;